import { useSupabaseQuery } from './useSupabaseQuery';

/**
 * Pipeline global de ofertas — view v_ofertas_pipeline.
 * Inclui counts (emails, propostas, context) e joins úteis para listagem.
 *
 * filters.showDiscarded — quando false (default) esconde status 9.*.
 */
export function useOfertasPipeline(filters = {}) {
  const showDiscarded = !!filters.showDiscarded;
  return useSupabaseQuery(
    (sb) => {
      let q = sb.from('v_ofertas_pipeline').select('*');
      if (!showDiscarded) q = q.not('status', 'ilike', '9.%');
      return q.order('updated_at', { ascending: false, nullsFirst: false });
    },
    [showDiscarded]
  );
}
